/**
 * Banner navigation
 *
 */

import { isoTabbing } from '../util/tabbing';
// import useMobileDetect from 'use-mobile-detect-hook';

/**
 * Create navigation
 */
const Nav = () => {
  const banner = document.querySelector('.banner'); // Banner wrapper
  const nav = banner?.querySelector('.banner__nav'); // Banner navigation
  const hamburger = banner?.querySelector('.banner__hamburger'); // Mobile Hamburger button
  const navClass = [banner, nav, document.body]; // Spread and [toggle] All Mobile Nav classes at once

  // Is there a navigation? Sweet, we may begin our journey
  if (nav) {
    // // close menu on window resize
    // window.addEventListener('resize', function () {
    //   const detectMobile = useMobileDetect();

    //   // desktop only: ripple effect
    //   if (detectMobile.isDesktop()) {
    //     nav?.querySelectorAll('[aria-expanded="true"]').forEach(el => {
    //       el.setAttribute('aria-expanded', 'true');
    //     });

    //     nav?.querySelectorAll('.active').forEach(el => {
    //       el.classList.remove('active');
    //     });

    //     navClass?.forEach(cls => cls.classList.remove('nav-open'));

    //     hamburger?.setAttribute('aria-expanded', 'false');

    //     banner?.querySelector('.banner__cta')?.classList.remove('active')
    //   }
    // });

    // Close Desktop Navigation
    const toggleNav = (link?: Element) => {
      if (link) {
        const linkParent = link.parentElement;
        if (linkParent) {
          const parentsParent = linkParent.parentElement; // Get the parent of the parent i.e. <ul>

          // Toggle .active class
          if (linkParent.classList.contains('active')) {
            // Close menu
            linkParent.classList.remove('active');
            link.setAttribute('aria-expanded', 'false');
            return 'collapsed single menu';
          } else {
            // Let's use that parent's parent to remove all active classes from open menu items
            parentsParent.querySelectorAll('.menu-item-has-children').forEach(p => {
              p.classList.remove('active');
              p.querySelector('.menu-item')?.setAttribute('aria-expanded', 'false');
            });
            if (nav.contains(link) || link === hamburger) {
              // Now open the selected menu item
              linkParent.classList.add('active');
              link.setAttribute('aria-expanded', 'true');
            }
            return 'opened single menu';
          }
        }
      }

      nav.querySelectorAll('.menu-item-has-children').forEach(p => {
        p.classList.remove('active');
        p.querySelector('.menu-item')?.setAttribute('aria-expanded', 'false');
      });

      return 'collapsed all menus';
    };

    // Adding click event to hamburger menu
    if (hamburger) {
      hamburger.addEventListener('click', (e) => {
        e.preventDefault();
        navClass.forEach(cls => cls.classList.toggle('nav-open'));
      });

      // Setup keyDown event for hamburger menu item
      hamburger.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.keyCode === 27 || e.key === 'Escape') {
          navClass.forEach(cls => cls.classList.remove('nav-open'));
        }
      });
    }

    // Setup sub menus
    const subMenus = nav.querySelectorAll('.menu-item[aria-haspopup="true"]');
    // Have any sub menus been added to the navigation? Coolio, you may now proceed
    if (subMenus) {
      // Loop through all subMenus
      [...subMenus].map(link => {
        // Setup the event listeners for the toggle link
        link.addEventListener('click', (e) => {
          e.preventDefault(); // Prevent href
          toggleNav(link);
        });

        link.addEventListener('keydown', (e) => {
          if (e.code === 'Space') {
            e.preventDefault(); // Prevent href
            toggleNav(link);
          }
        });
      });
    }
    // Close the menu if clicked outside of nav
    document.addEventListener('click', (e: MouseEvent) => {
      if (nav.contains(e.target)) {
        // Clicked in nav area (business as usual)
      } else {
        // Clicked outside nav (let's do stuff)
        toggleNav(e.currentTarget);
        if (e.target !== hamburger) {
          const targetHrefString = e.target.href;
          // if nav is open
          if (
            (document.body.classList.contains('nav-open'))
            && (
              // and href contains an anchor
              (e.target.href?.includes('#'))
              // or the target is rmiButton
              || (targetHrefString?.includes('getmoreinformation'))
            )
          ) {
            navClass.forEach(cls => cls.classList.remove('nav-open'));
          }
        }
      }
    });

    // Close the menu if key event outside of nav (use focusin as it bubbles up to the document)
    document.addEventListener('focusin', (e: FocusEvent) => {
      if (nav.contains(e.target)) {
        // Focused in nav area (business as usual)
        if (!isMenuOpen(e.target)) {
          // close all nav items if the current menu item isn't part of an open menu block
          toggleNav();
        }
      } else {
        // Focused outside nav (let's do stuff)
        toggleNav();
      }
    });

    /**
     * Checks to see if the link has any parents that are expanded by recursively climbing up the DOM
     * searching for the "active" class.
     */
    const isMenuOpen = (childLink) => {
      // check self first
      if (childLink?.classList.contains('active')) {
        return true; // has active class
      }

      // if not, check if the parent has has
      if (childLink?.parentElement) {
        return isMenuOpen(childLink.parentElement); // keep climbing
      }

      return false; // found no parent element with "active" class
    };

    // Listen for keyDown events on nav banner
    nav.addEventListener('keydown', (e: KeyboardEvent) => {
      // escape key - close entire nav;
      if (e.keyCode === 27 || e.key === 'Escape') {
        if (window.innerWidth < 992) {
          // Mobile
          navClass.forEach(cls => cls.classList.remove('nav-open'));
        } else {
          // Desktop
          toggleNav();
        }
      }

      // Isolate tabbing when in mobile
      if (window.innerWidth < 992) {
        // Isolate tabbing inside Nav -> last tab goes to hamburger menu
        isoTabbing(e.currentTarget, e, hamburger);
      }
    });
  }
};

export default Nav;
